import { useTranslation } from 'react-i18next';
import classes from './Regulations.module.scss';
import image from '../../../assets/img/Home/regulations.avif';

const cards = [
    {
        subtitle: 'home.regulations.subtitle_04',
        desc: 'home.regulations.text_05',
    },
    {
        subtitle: 'home.regulations.subtitle_05',
        desc: 'home.regulations.text_06',
    },
];

const Regulations = () => {
    const { t } = useTranslation();
    return (
        <section className="mt container">
            <div className={classes.wrap}>
                <div className={classes.body}>
                    <div className={classes.main}>
                        <h2 className={`${classes.title} font-48`}>
                            {t('home.regulations.title')}
                        </h2>
                        <h4 className={`${classes.subtitle} font-20`}>
                            {t('home.regulations.subtitle_01')}
                        </h4>
                        <p className={`${classes.text} font-16`}>
                            {t('home.regulations.text_01')}
                        </p>
                    </div>
                    <div className={classes.bottom}>
                        <h4 className={`${classes.subtitle} font-20`}>
                            {t('home.regulations.subtitle_02')}
                        </h4>
                        <p className={`${classes.text} font-16`}>
                            {t('home.regulations.text_02')}
                        </p>
                        <ul className={`${classes.list} font-16`}>
                            <li>
                                <p>D&B D-U-N-S® {t('home.regulations.text_03')}</p>
                                <p><b>1083589</b></p>
                            </li>
                            <li>
                                <p>{t('home.regulations.text_04')}</p>
                                <p><b>1083589</b></p>
                            </li>
                        </ul>
                        <p className={`${classes.info} font-20`}>
                            {t('home.regulations.subtitle_03')}
                        </p>
                    </div>
                </div>
                <div className={classes.content}>
                    <img className={classes.image} src={image} alt='' />
                    <div className={classes.cards}>
                        {cards.map((card, index) =>
                            <div key={index} className={classes.card}>
                                <div className={classes.head}>
                                    <svg className={classes.check} xmlns="http://www.w3.org/2000/svg" width="34" height="29" viewBox="0 0 34 29" fill="none">
                                        <g clipPath="url(#clip0_2090_239)">
                                            <path d="M9.19006 28.4202C6.4942 23.173 3.45075 18.1117 0.0800619 13.2702C0.0192155 13.1884 -0.0105735 13.0876 -0.00398348 12.9858C0.00260659 12.8841 0.0451496 12.788 0.116042 12.7147C0.186935 12.6414 0.281559 12.5957 0.38304 12.5857C0.484522 12.5757 0.586249 12.6021 0.670058 12.6602C3.56931 14.661 6.36304 16.8106 9.04005 19.1002C9.09674 19.1499 9.16305 19.1875 9.23485 19.2105C9.30665 19.2335 9.38242 19.2415 9.45744 19.234C9.53247 19.2265 9.60514 19.2036 9.67096 19.1669C9.73678 19.1301 9.79434 19.0802 9.84006 19.0202C11.8401 16.6102 21.4601 5.22022 33.0201 0.0202162C33.1046 -0.0237171 33.2028 -0.0333583 33.2943 -0.00670027C33.3857 0.0199578 33.4634 0.0808593 33.511 0.163328C33.5587 0.245798 33.5727 0.343478 33.5502 0.436033C33.5277 0.528589 33.4703 0.60889 33.3901 0.660216C22.0001 9.03022 12.5001 24.5002 10.2001 28.4302C10.1486 28.5192 10.0745 28.5929 9.98529 28.6438C9.89605 28.6947 9.79488 28.721 9.69214 28.72C9.5894 28.719 9.48878 28.6907 9.40056 28.638C9.31234 28.5853 9.2397 28.5102 9.19006 28.4202Z" fill="#D71924" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_2090_239">
                                                <rect width="33.55" height="28.73" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <h4 className={`${classes.subtitle} font-20`}>
                                        {t(card.subtitle)}
                                    </h4>
                                </div>
                                <p className={`${classes.desc} font-16`}>
                                    {t(card.desc)}
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Regulations;
